import { Outlet, useNavigate, useLocation, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { UserButton, SignedIn, SignedOut } from "@clerk/react-router";
import BottomNav from "./BottomNav";
import Footer from "./Footer";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { Logo } from "./Logo";

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Top Navigation - Mobile & Desktop */}
      <header className="sticky top-0 z-40 w-full bg-gradient-to-r from-[var(--surface-container)] to-[var(--surface-container-high)]">
        <div className="container mx-auto flex h-14 md:h-14 items-center justify-between px-4 md:px-4 gap-2">
          <div className="flex items-center gap-2 shrink-0">
            <Link to="/dashboard" className="flex items-center">
              <Logo variant="small" className="h-7 w-auto" />
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-1 flex-1 justify-center min-w-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/dashboard")}
              className={cn(
                "px-3 text-sm h-9",
                location.pathname === "/dashboard" && "bg-[var(--primary-container)] text-[var(--primary-container-foreground)]"
              )}
            >
              Dashboard
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/income")}
              className={cn(
                "px-3 text-sm h-9",
                location.pathname === "/income" && "bg-[var(--primary-container)] text-[var(--primary-container-foreground)]"
              )}
            >
              Income
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/expenses")}
              className={cn(
                "px-3 text-sm h-9",
                location.pathname === "/expenses" && "bg-[var(--primary-container)] text-[var(--primary-container-foreground)]"
              )}
            >
              Expenses
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/savings")}
              className={cn(
                "px-3 text-sm h-9",
                location.pathname === "/savings" && "bg-[var(--primary-container)] text-[var(--primary-container-foreground)]"
              )}
            >
              Savings
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/settings")}
              className={cn(
                "px-3 text-sm h-9",
                location.pathname === "/settings" && "bg-[var(--primary-container)] text-[var(--primary-container-foreground)]"
              )}
            >
              Settings
            </Button>
          </nav>

          <div className="flex items-center gap-2 shrink-0">
            <UserButton
              appearance={{
                elements: {
                  avatarBox: "w-8 h-8 md:w-9 md:h-9",
                },
              }}
              afterSignOutUrl="/"
            />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 pb-16 md:pb-0">
        <div className="container mx-auto px-4 md:px-6 py-4 md:py-6 max-w-7xl">
          <Outlet />
        </div>
      </main>

      {/* Bottom Navigation - Mobile Only */}
      <BottomNav />

      {/* Footer */}
      <Footer />
    </div>
  );
}
